import { FAQPageJsonLd } from "next-seo";

const FAQPage = ({ faqs }) => {
  return (
   <FAQPageJsonLd
      mainEntity={faqs.map((faq) => ({
        questionName: faq.question,
        acceptedAnswerText: faq.answer,
      }))}
    />
  );
};

export default FAQPage;